import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
  Select,
  Flex,
} from "@chakra-ui/react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

export default function AddRemarkModal({ isOpen, onClose, userId, fetchRemarks, fetchMarksData }) {
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const handleSave = () => {
    const newRemark = { type, description, userId };
    if(!type || !description) {
      toast.error("Wypełnij wszystkie pola");
      return;
    }
    console.log(newRemark, "tak");
    axios
      .post(`${apiUrl}/data/school/company/remarks/add`, newRemark, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie dodano uwagę");
        fetchRemarks();
        fetchMarksData();
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas dodawania uwagi");
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Dodaj uwagę</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap="4">
            <Select
              placeholder="Wybierz typ uwagi"
              value={type}
              onChange={(e) => setType(e.target.value)}
              mb={3}
            >
              <option value="1">Pozytywna</option>
              <option value="0">Negatywna</option>
            </Select>
            <Textarea
              placeholder="Opis uwagi"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              mb={3}
            />
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={onClose}>
            Anuluj
          </Button>
          <Button colorScheme="green" onClick={handleSave}>
            Dodaj uwagę
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}